module.exports = __webpack_public_path__ + "static/media/Electrodes_vet_crabs.6aef12d0.png";